module.exports = __webpack_public_path__ + "static/media/How to change password for the other users.8c0d1494.png";